export const socialNetworks = {
    instagram: "instagram",
    youtube: "youtube",
    tiktok: "tiktok"
}